export const DeliveryListSupplierPage = () => {
    return <>DeliveryListSupplierPage</>
}
